const mobilePageHeights = [
  { page: '1', height: 1.25 },
  { page: '2', height: 0.5 },
  { page: '3', height: 1.5 },
  { page: '4', height: 1.25 },
  { page: '5', height: 1.5 },
  { page: '6', height: 1.75 },
  { page: '7', height: 0.6 },
  { page: '9', height: 1.15 },
  { page: '11', height: 1.5 },
  { page: '13', height: 1.25 },
  { page: '16', height: 1.5 },
  { page: '19', height: 2 },
  { page: '22', height: 0.75 },
  { page: '24', height: 0.5 },
  { page: '27', height: 0.5 },
  { page: '28', height: 1.25 },
  { page: '29', height: 0.5 },
  { page: '32', height: 0.75 },
  { page: '36', height: 0.75 },
  { page: '37', height: 2.25 },
  { page: '38', height: 1.5 },
  
];

export function getMobilePageHeight(pageId, defaultHeight) {
  const definition = mobilePageHeights.find(entry => String(entry.page) === String(pageId));
  const multiplier = definition?.height;
  return Number.isFinite(multiplier) && multiplier > 0 ? defaultHeight * multiplier : defaultHeight;
}

export default mobilePageHeights;